import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import userReducer from "../slice/userSlice";
import trainerReducer from "../slice/trainerSlice";
import programReducer from "../slice/programSlice";
import localStorage from "redux-persist/lib/storage";
import {
  persistStore,
  persistReducer,
  FLUSH,
  PERSIST,
  REHYDRATE,
  PAUSE,
  PURGE,
  REGISTER,
} from "redux-persist";
import cartReducer from '../slice/cartSlice';

const persistConfig = {
  key: "root",
  storage: localStorage,
  whitelist: ['user', 'cart']
};

const rootReducer = combineReducers({
  user: userReducer,
  trainer: trainerReducer,
  program: programReducer,
  cart: cartReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
